import { render } from "./AddLinkModal.vue?vue&type=template&id=06bd986e&scoped=true&ts=true"
import script from "./AddLinkModal.vue?vue&type=script&lang=ts"
export * from "./AddLinkModal.vue?vue&type=script&lang=ts"

import "./AddLinkModal.vue?vue&type=style&index=0&id=06bd986e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bd986e"]])

export default __exports__